export default __webpack_public_path__ + "static/media/our-services-social-care-elderly-care-services.6d4a62f4.jpg";